module.exports = "/_next/static/images/708ca458da592204422b7077a641376c-paperwork@desktop1024.jpg.webp";